
import React, { useCallback, useState } from 'react';

import ModalSelectionItem from '~/components/ModalSelectionItem';
import SpinnerOverlay from '~/components/SpinnerOverlay';
import { extractRequestError } from '~/helpers/error-helper';
import { wrapFormField } from '~/helpers/form-helper';
import useAsync from '~/hooks/use-async';
import useAxios from '~/hooks/use-axios';
import useDidMountAndUpdate from '~/hooks/use-did-mount-and-update';

import CompaniesModal from './CompaniesModal';
import styles from './CompanySelect.module.scss';

const CompanySelect = ({
    input, label,
}) => {
    const api = useAxios();
    const [companyData, setCompanyData] = useState(null);
    const { value, onChange } = input;

    const handleChoose = useCallback(() => {
        CompaniesModal.show({ onChange });
    }, [onChange]);

    const { call: requestCompany, loading } = useAsync(async companyId => {
        try {
            const { data } = await api.get(`/Company/GetCompanyById/${companyId}`);

            setCompanyData(data);
        } catch (err) {
            extractRequestError(
                err,
                'Não foi possível buscar a empresa. Por favor, selecione a empresa novamente.',
            );
        }
    }, [api]);

    useDidMountAndUpdate(() => {
        if (value) {
            requestCompany(value);
        } else {
            setCompanyData(null);
        }
    }, [value]);

    const renderCompany = useCallback(() => {
        if (loading) {
            return (
                <SpinnerOverlay spinning />
            );
        }

        if (!companyData) {
            return (
                <div className={styles.placeholder}>
                    Escolha uma empresa...
                </div>
            );
        }

        const { name, internalAddress, category } = companyData;

        return (
            <div className={styles.value}>
                {name} - {internalAddress} - {category}
            </div>
        );
    }, [companyData, loading]);

    return (
        <ModalSelectionItem
            render={renderCompany}
            value={value}
            label={label}
            onOpenModal={handleChoose}
            emptyMessage="Escolha uma empresa..."
            searchMessage="Selecionar empresa"
        />
    );
};

CompanySelect.Field = wrapFormField(CompanySelect);

export default CompanySelect;
